import React, { useEffect, useState } from "react";
import "./../../styles/Vendor.css";
import dashboardcard1 from "../../assets/dashboard card1.webp";
import dashboardcard2 from "../../assets/dashboard card2.webp";
import dashboardcard3 from "../../assets/dashboard card3.webp";
import dashboardcard4 from "../../assets/dashboard card4.webp";
import dashboardcard5 from "../../assets/dashboard card5.webp";
import GenerateLink from "./GenerateLink";
import toast from "react-hot-toast";
import api from "../../config/URL";
import { FiSearch } from "react-icons/fi";

function DashboardA() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");

  const getData = async () => {
    setLoading(true);
    try {
      const response = await api.get(`affiliate/dashboard`, {
        params: {
          start_date: startDate,
          end_date: endDate,
        },
      });

      setData(response.data.data);
    } catch (error) {
      toast.error("Error fetching data: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setMaxDate(today);
    setEndDate(today);

    const getDashboardData = async () => {
      setLoading(true);
      try {
        const response = await api.get(`affiliate/dashboard`);

        setData(response.data.data);
        if (response?.data?.data?.last_payout_paid_at) {
          setStartDate(
            response?.data?.data?.last_payout_paid_at?.split(" ")[0]
          );
        } else {
          setStartDate(
            response?.data?.data?.affiliate_account_created_at?.split(" ")[0]
          );
        }
        setMinDate(
          response?.data?.data?.affiliate_account_created_at?.split(" ")[0]
        );
      } catch (error) {
        toast.error("Error fetching data: " + error.message);
      } finally {
        setLoading(false);
      }
    };

    getDashboardData();
  }, []);

  const handleSearch = () => {
    if (startDate && endDate) {
      getData();
    } else {
      toast.error("Please select both start and end dates");
    }
  };

  return (
    <section>
      {loading ? (
        <div className="loader-container">
          <div className="loader">
            <svg viewBox="0 0 80 80">
              <circle cx="40" cy="40" r="32"></circle>
            </svg>
          </div>
        </div>
      ) : (
        <>
          <div
            className="card shadow border-0 mx-4"
            style={{ minHeight: "90vh" }}
          >
            <div className="container py-5">
              <div className="row d-flex align-items-center mb-3">
                <div className="col-md-3 col-lg-3 col-sm-12">
                  <label className="form-label">Start Date</label>
                  <input
                    type="date"
                    className="form-control"
                    style={{ boxShadow: "none" }}
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    min={minDate}
                    max={endDate || maxDate}
                  />
                </div>
                <div className="col-md-3 col-lg-3 col-sm-12">
                  <label className="form-label">End Date</label>
                  <input
                    type="date"
                    className="form-control"
                    style={{ boxShadow: "none" }}
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    min={startDate || minDate}
                    max={maxDate}
                  />
                </div>
                <div className="col-md-2 col-lg-2 col-sm-12">
                  <div className="mt-md-5 mt-sm-0">
                    <button
                      className="btn btn-sm"
                      style={{
                        background: "#ff0060",
                        color: "#fff",
                        boxShadow: "none",
                      }}
                      onClick={handleSearch}
                    >
                      <FiSearch /> Search
                    </button>
                  </div>
                </div>
                <div className="col-md-4 col-lg-4 col-sm-12 d-flex justify-content-sm-start justify-content-md-end justify-content-lg-end">
                  <GenerateLink />
                </div>
              </div>
              <p>
                Minimum Withdrawal Amount :{" "}
                {data?.minimum_withdrawal_amount
                  ? new Intl.NumberFormat("en-IN", {
                      style: "currency",
                      currency: "INR",
                      maximumFractionDigits: 0,
                    }).format(data.minimum_withdrawal_amount)
                  : "0"}
              </p>
            </div>

            <div className="row card-container p-4">
              <div className="col-12 col-md-6 col-lg-3 mb-4">
                <div
                  style={{
                    background: "#1A2E86",
                    borderRadius: "8px",
                  }}
                  className="card h-100"
                >
                  <div className="card-content p-2">
                    <div className="d-flex align-items-center">
                      <h2 className="text-white">{data.products_sold || 0}</h2>
                    </div>
                    <p className="text-white">Products Sold</p>
                    <div className="flex-grow-1">
                      <img
                        src={dashboardcard1}
                        alt=""
                        className="img-fluid"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-4">
                <div
                  style={{
                    background: "#237BFF",
                    borderRadius: "8px",
                  }}
                  className="card h-100"
                >
                  <div className="card-content p-2">
                    <div className="d-flex justify-content-between">
                      <h2 className="text-white">
                        {data?.total_amount
                          ? new Intl.NumberFormat("en-IN", {
                              style: "currency",
                              currency: "INR",
                              maximumFractionDigits: 0,
                            }).format(data.total_amount)
                          : "0"}
                      </h2>
                    </div>
                    <p className="text-white">Total Sales Generated</p>
                    <div className="flex-grow-1">
                      <img
                        src={dashboardcard4}
                        alt=""
                        className="img-fluid"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-4">
                <div
                  style={{
                    background: "#eb4034",
                    borderRadius: "8px",
                  }}
                  className="card h-100"
                >
                  <div className="card-content p-2">
                    <div className="d-flex justify-content-between">
                      <h2 className="text-white">
                        {data?.total_commission
                          ? new Intl.NumberFormat("en-IN", {
                              style: "currency",
                              currency: "INR",
                              maximumFractionDigits: 0,
                            }).format(data.total_commission)
                          : "0"}
                      </h2>
                    </div>
                    <p className="text-white">Commission Earned</p>
                    <div className="flex-grow-1">
                      <img
                        src={dashboardcard5}
                        alt=""
                        className="img-fluid"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-4">
                <div
                  style={{
                    background: "#FFB63A",
                    borderRadius: "8px",
                  }}
                  className="card h-100"
                >
                  <div className="card-content p-2">
                    <div className="d-flex justify-content-between">
                      <h2 className="text-white">
                        {data?.total_balance	
                          ? new Intl.NumberFormat("en-IN", {
                              style: "currency",
                              currency: "INR",
                              maximumFractionDigits: 0,
                            }).format(data.total_balance	)
                          : "0"}
                      </h2>
                    </div>
                    <p className="text-white">Available Balance</p>
                    <div className="flex-grow-1">
                      <img
                        src={dashboardcard3}
                        alt=""
                        className="img-fluid"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-4">
                <div
                  style={{
                    background: "#fb8b33",
                    borderRadius: "8px",
                  }}
                  className="card h-100"
                >
                  <div className="card-content p-2">
                    <div className="d-flex justify-content-between">
                      <h2 className="text-white">
                        {data?.total_payouts
                          ? new Intl.NumberFormat("en-IN", {
                              style: "currency",
                              currency: "INR",
                              maximumFractionDigits: 0,
                            }).format(data.total_payouts)
                          : "0"}
                      </h2>
                    </div>
                    <p className="text-white">Payouts</p>
                    <div className="flex-grow-1">
                      <img
                        src={dashboardcard2}
                        alt=""
                        className="img-fluid"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-4">
                <div
                  style={{
                    background: "#92462e",
                    borderRadius: "8px",
                  }}
                  className="card h-100"
                >
                  <div className="card-content p-2">
                    <div className="d-flex justify-content-between">
                      <h2 className="text-white">
                        {data?.total_pending_payouts
                          ? new Intl.NumberFormat("en-IN", {
                              style: "currency",
                              currency: "INR",
                              maximumFractionDigits: 0,
                            }).format(data.total_pending_payouts)
                          : "0"}
                      </h2>
                    </div>
                    <p className="text-white">Pending Payouts</p>
                    <div className="flex-grow-1">
                      <img
                        src={dashboardcard2}
                        alt=""
                        className="img-fluid"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <p>{data.percentage}% commission applied to each order</p>
            </div>
          </div>
        </>
      )}
    </section>
  );
}

export default DashboardA;
